import styled from 'styled-components';
import { Box } from '@components/Box';
import { Columns } from '@components/Columns';
import { themeMediaQuery } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';

export const StyledBox = styled(Box)`
  position: relative;
`;

export const StyledSvg = styled.svg`
  position: absolute;
  right: 0%;
  top: 53%;
  ${themeMediaQuery('below_sm')} {
    top: 43%;
    width: 17%;
  }
}
`;

export const StyledColumns = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    display: flex;
    flex-direction: column;
  }
`;

export const StyledColumn = styled(Columns.Column)`
  ${themeMediaQuery('below_sm')} {
    display: flex;
  }
`;

export const StyledColumnText = styled(StyledColumn)`
  ${themeMediaQuery('below_sm')} {
    order: 2;
  }
`;

export const StyledTextPairing = styled(TextPairing)`
  ${themeMediaQuery('below_sm')} {
    align-items: center;
  }
  .text-pairing-title {
    ${themeMediaQuery('below_sm')} {
      text-align: center;
    }
  }
  .text-pairing-body {
    max-width: 330px;
    ${themeMediaQuery('below_sm')} {
      text-align: center;
      max-width: 232px;
      margin: auto;
    }
  }
`;
